import { useEffect } from "react";
import { tokenManager } from "../../Api/tokenManager";

export default function useHospitalProviderRole() {
  useEffect(() => {
    tokenManager.setActiveProviderRole("hospital");
  }, []);
}
